// Convenience hook for gating per-action UI (Add / Edit / Delete buttons)
// inside a page, on top of the page-level "view" gate RequirePermission
// already applies at the route level. Master pages previously showed their
// Edit/Delete icons and "Add X" button to every viewer regardless of the
// signed-in user's actual Module Permissions — a role with only "View"
// checked could still see (and click into) Edit/Delete actions.
import { authStore } from '@/context/auth'
import { useMasterData } from '@/context/MasterDataContext'
import { hasModulePermission, type ModuleName } from '@/utils/permissions'

export function useModulePermission(moduleName: ModuleName) {
  const { roles } = useMasterData()
  const user = authStore.getUser()

  return {
    canView: hasModulePermission(user, roles, moduleName, 'view'),
    canAdd: hasModulePermission(user, roles, moduleName, 'add'),
    canEdit: hasModulePermission(user, roles, moduleName, 'edit'),
    canDelete: hasModulePermission(user, roles, moduleName, 'delete'),
    canEmail: hasModulePermission(user, roles, moduleName, 'email'),
    canDownload: hasModulePermission(user, roles, moduleName, 'download'),
    canApprove: hasModulePermission(user, roles, moduleName, 'approve'),
    canReject: hasModulePermission(user, roles, moduleName, 'reject'),
  }
}
